import PropTypes from "prop-types"
import React, { Component } from "react"
import { connect } from "react-redux"
import { Link } from "react-router-dom"
import { bindActionCreators } from "redux"
import DamageCaseIcon from "../../images/icons/damage_case-104.png"
import LhoHeaderText from "../common/LhoHeaderText"
import * as actions from "./redux/actions"
import { DamageCaseShape } from "./redux/shapes"
import PictureCanvas from "./PictureCanvas"

export class UnsentCasesPage extends Component {
  static propTypes = {
    unsentCases: PropTypes.objectOf(DamageCaseShape),
    actions: PropTypes.object.isRequired,
  }

  render() {
    const { unsentCases } = this.props
    const casesFlat = unsentCases
      ? Object.getOwnPropertyNames(unsentCases).map(caseId => ({ caseId, caseData: unsentCases[caseId] }))
      : []

    return (
      <div className="damage-case-unsent-cases-page">
        <div className="app-content">
          <div className="app-content_middle unsent-cases-list">
            {casesFlat.map(({ caseId, caseData }) => (
              <Link key={caseId} className="item" to={`/case/${caseId}/pictures`}>
                <img className="icon icon-damage_case" alt="icon" src={DamageCaseIcon} />
                <div className="pictures">
                  {caseData.pictures.map((picture, idx) => (
                    <PictureCanvas
                      key={`${idx + 1}_${picture.timestamp}`}
                      className="picture"
                      pictureBase64={picture.base64}
                      drawingData={picture.drawingData}
                      drawingEnabled={false}
                      width={60}
                    />
                  ))}
                </div>
                <div className="lho-item">
                  <LhoHeaderText lhoRef={caseData.lhoRef} />
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    )
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    unsentCases: state.damageCase.unsentCases,
  }
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(UnsentCasesPage)



// WEBPACK FOOTER //
// ./src/features/damage-case/UnsentCasesPage.js